module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12 offset"
  }, [(_vm.done) ? _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Drought Levels by " + _vm._s(_vm.droughtType))]), _vm._v(" "), _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-drought"
  }, [_vm._v("\n      The following chart shows drought level by " + _vm._s(_vm.droughtTypeLower) + " as reported by the\n      "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://droughtmonitor.unl.edu"
    }
  }, [_vm._v("United States Drought Monitor")]), _vm._v(". Drought levels are represented by a series of nested\n      circles. The larger the circle the greater percentage of the " + _vm._s(_vm.droughtTypeLower) + " that is at that drought level.\n    In extreme cases, e.g. 100% drought levels, the circles will overlap. If there is no drought in a " + _vm._s(_vm.droughtTypeLower) + "\n    there won't be any circles at all. Hover over a circle to see the levels for a\n    particular " + _vm._s(_vm.droughtTypeLower) + ". See the legends below the map for full details.")]), _vm._v(" "), _c('vue-slider', _vm._b({
    ref: "slider",
    on: {
      "callback": _vm.updateSlider
    },
    model: {
      value: (_vm.slider_data.value),
      callback: function($$v) {
        _vm.slider_data.value = $$v
      },
      expression: "slider_data.value"
    }
  }, 'vue-slider', _vm.slider_data))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [_c('svg', {
    staticClass: "is-map",
    attrs: {
      "id": "drought_map",
      "height": _vm.graph_height,
      "width": _vm.graph_width
    }
  }, [_vm._l((_vm.centers), function(d, index) {
    return [_c('g', {
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    }, _vm._l((_vm.num_circles), function(j) {
      return _c('circle', {
        style: ({
          stroke: _vm.colors[j]
        }),
        attrs: {
          "cx": _vm.projection([d.lon, d.lat])[0],
          "cy": _vm.projection([d.lon, d.lat])[1],
          "r": _vm.findValue(d, _vm.filtered_data, j)
        }
      })
    }))]
  })], 2), _vm._v(" "), _c('drought-legend-chart', {
    attrs: {
      "colors": _vm.colors
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offset-sm-1 col-sm-10"
  }, [_c('p', [_vm._v("If you have any questions or comments feel free to contact me via Twitter at @farrelldlfarrel, or email\n        at farrelldlfarrell at gmail.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-142860da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DroughtMap.vue
// module id = 364
// module chunks = 1